<template>
  <!-- Loading message when isLoading is true -->
  <div
    v-if="isLoading"
    class="d-flex justify-content-center align-items-center"
    style="height: 40vh"
  >
    <div class="custom-spinner" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <!-- Error Handling -->
  <div v-if="!isLoading && errorMessage.length > 0" class="alert alert-danger">
    <strong>Erro!</strong> {{ errorMessage }}
  </div>
</template>
<script>
export default {
  data() {
    return {
      errorMessage: '', // Error message to display to the user
      isLoading: false, // Sets the Loading Spinner On and Off
    };
  },

  methods: {
    // handle error messages
    errorHandling(error) {
      this.errorMessage = error;
      if (this.errorMessage.length > 0) {
        // Scroll to the top of the page
        window.scrollTo({
          top: 0,
          behavior: 'smooth', // Scroll behavior
        });
      }
    },

    //Set the isLoading value
    setLoading(value) {
      this.isLoading = value;
    },

    // Define the delay method
    async delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    // method to dispatch the store action to get the excel file and then change path
    async dispatchMethod() {
      // set loading
      this.setLoading(true);

      // get the parameters from the url entered (maxDate, minDate and token)
      const queryParams = new URLSearchParams(this.$route.query);

      // Extract the minDate and maxDate parameters
      const minDate = queryParams.get('minDate');
      const maxDate = queryParams.get('maxDate');
      // Regular expression to validate date format (yyyy-mm-dd)
      const dateFormatRegex = /^\d{4}-\d{2}-\d{2}$/;
      // Validate the date format
      const isValidDateFormat = (dateString) => {
        if (!dateString.match(dateFormatRegex)) return false;

        const date = new Date(dateString);
        const timestamp = date.getTime();

        if (typeof timestamp !== 'number' || Number.isNaN(timestamp))
          return false;

        return dateString === date.toISOString().split('T')[0];
      };
      // Check if minDate and maxDate are provided and validate their formats
      if (
        (minDate && !isValidDateFormat(minDate)) ||
        (maxDate && !isValidDateFormat(maxDate))
      ) {
        this.setLoading(false);
        this.errorHandling('Datas com formato inválido');
        // we wait 10 seconds for user to see error message if there is any
        await this.delay(10000);
        return;
      }

      // dispatch the action
      var resultMessage = await this.$store.dispatch(
        'backoffice/downloadFileBackoffice',
        queryParams
      );

      // finnish loading
      this.setLoading(false);
      
      // handle error
      if (resultMessage) {
        this.errorHandling(resultMessage);
        // we wait 10 seconds for user to see error message if there is any
        await this.delay(10000);
      }
    },
  },

  async mounted() {
    // show loading spinner
    this.setLoading(true);

    // when the component mounts we dispatch the action
    await this.dispatchMethod();

    // remove loading spinner
    this.setLoading(false);

    // and re route to the home
    this.$router.replace('/home');
  },
};
</script>